import type { Catalogs, Translation } from "@amtana/i18n/catalog";

// Every word on the purge-data panel and the Settings page's title, in English and Spanish.
// `useSettingsCopy` (behavior/use-settings-copy.ts) reads the active language.

export type SettingsCopyKey = keyof typeof EN;
export type SettingsCatalog = typeof EN;

const EN = {
  screenTitle: "Settings · {product}",
  purgeTitle: "Purge Data Completely",
  purgeDescription:
    "Initiating this action will irrevocably wipe out all your stored data within the software. Once purged, the data can never be retrieved or restored. Ensure you've backed up essential data before proceeding.",
  willDelete: "This will delete:",
  localProspects: "All your local prospects",
  localAnalysis: "All your local analysis",
  willNotDelete: "This will not delete:",
  organizationAndMembers: "Your organization and its members",
  yourSettings: "Your settings",
  yourAccount: "Your account",
  storageUsed: "Total storage used: {size} MB ({prospects})",
  prospectCount: { one: "1 prospect", other: "{count} prospects" },
  analysisCount: { one: "1 analysis", other: "{count} analyses" },
  confirmDelete: "Confirm that I want to delete all the data.",
  delete: "Delete",
  deleted: "Deleted {analyses} and {prospects}",
  couldNotDelete: "Could not delete your data",
} as const;

const ES: Translation<SettingsCatalog> = {
  screenTitle: "Configuración · {product}",
  purgeTitle: "Eliminar todos los datos",
  purgeDescription:
    "Esta acción borra de forma irreversible todos los datos que guardaste en el software. Una vez eliminados, no se pueden recuperar ni restaurar. Asegúrate de haber respaldado lo esencial antes de continuar.",
  willDelete: "Esto eliminará:",
  localProspects: "Todos tus prospectos locales",
  localAnalysis: "Todos tus análisis locales",
  willNotDelete: "Esto no eliminará:",
  organizationAndMembers: "Tu organización y sus miembros",
  yourSettings: "Tu configuración",
  yourAccount: "Tu cuenta",
  storageUsed: "Almacenamiento total usado: {size} MB ({prospects})",
  prospectCount: { one: "1 prospecto", other: "{count} prospectos" },
  analysisCount: { one: "1 análisis", other: "{count} análisis" },
  confirmDelete: "Confirmo que quiero eliminar todos los datos.",
  delete: "Eliminar",
  deleted: "Se eliminaron {analyses} y {prospects}",
  couldNotDelete: "No se pudieron eliminar tus datos",
};

export const SETTINGS_CATALOGS: Catalogs<SettingsCatalog> = { en: EN, es: ES };
